import {CSSProperties, FC} from 'react';


export interface IIconSpecPriceBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconSpecPriceBmw: FC<IIconSpecPriceBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M20.78 12.266 11.734 3.22a.752.752 0 0 0-.656-.21L4.693 4.074a.752.752 0 0 0-.619.619L3.01 11.078a.753.753 0 0 0 .21.656l9.046 9.046a.753.753 0 0 0 1.064 0l7.45-7.45a.753.753 0 0 0 0-1.064ZM8.519 8.52a1.565 1.565 0 1 1-2.213-2.213 1.565 1.565 0 0 1 2.213 2.213Zm2.683 4.811a.752.752 0 1 1-1.064-1.063.752.752 0 0 1 1.064 1.063Zm2.341 3.831-1.49-.212 1.064-7.45 1.49.213-1.064 7.45Zm2.98-2.766a.752.752 0 1 1-1.064-1.064.752.752 0 0 1 1.064 1.064Z" />
        </svg>
    );
};
